import { GameIcon } from './game-icon';
import { itemArtVariant, resolveItemArtFamily, type ItemArtSource } from './item-art.utils';
const files = import.meta.glob<string>('../../../assets/item-art/*.png', { eager: true, query: '?url', import: 'default' });
const families: Record<string, string[]> = {};
for (const [path, url] of Object.entries(files).sort(([a], [b]) => a.localeCompare(b))) {
  const family = path.split('/').pop()!.replace(/-\d+\.png$/, '');
  (families[family] ??= []).push(url);
}
/** Decorative artwork; the adjacent item name remains the accessible label. */
export function ItemArt({ item, size = 56 }: { item: ItemArtSource; size?: number }) {
  const family = resolveItemArtFamily(item);
  const variants = family ? families[family] : undefined;
  if (!variants?.length) return <GameIcon name="backpack" size={Math.min(size, 24)} />;
  return <img className="th-item-art" src={variants[itemArtVariant(item.id, variants.length)]} alt="" aria-hidden draggable={false}
    style={{ display: 'block', width: size, height: size, maxWidth: '100%', objectFit: 'contain', margin: '0 auto', flexShrink: 0 }} />;
}
